import { useState } from 'react'

import { LOCAL_STORAGE_KEYS } from 'config/Vars'

import Callout from 'modules/core/components/Callout'
import { useEffect } from 'modules/core/hooks/useEffect'
import { getNormalizedToday, i18nDateToString } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'
import useLocalStorage from 'modules/core/lib/useLocalStorage'

const CyclesLocationCallout = () => {
  const [isBeginningOfMonth, setIsBeginningOfMonth] = useState(false)
  const [isDismissedOnFirstDay, setIsDismissedOnFirstDay] = useLocalStorage<boolean>(
    LOCAL_STORAGE_KEYS.hasDismissedCyclesCalloutOnFirstDayOfMonth,
    false
  )
  const [isDismissed, setIsDismissed] = useLocalStorage<boolean>(
    LOCAL_STORAGE_KEYS.hideCyclesLocationCallout,
    false
  )

  useEffect(() => {
    const dateoday = getNormalizedToday()
    const day = i18nDateToString(dateoday, 'ui_day_initials_format')

    if (day === '1') {
      setIsBeginningOfMonth(true)
    } else {
      localStorage.removeItem(LOCAL_STORAGE_KEYS.hasDismissedCyclesCalloutOnFirstDayOfMonth)
    }
  }, [])

  const handleDismiss = () => {
    if (isBeginningOfMonth) {
      setIsDismissedOnFirstDay(true)
    }
    setIsDismissed(true)
  }

  const showCallout = () => {
    if (isBeginningOfMonth && !isDismissedOnFirstDay) {
      return true
    }
    if (isDismissed) {
      return false
    }

    return true
  }

  if (!showCallout()) {
    return null
  }

  return (
    <>
      <Callout
        type="info"
        title={i18n.t('bookkeepers.clients.payroll_cycles.callout_title')}
        description={i18n.t('bookkeepers.clients.payroll_cycles.callout_description')}
        onRemove={handleDismiss}
      />
    </>
  )
}

export { CyclesLocationCallout }
